import splitToWords from "./splitToWords";

var insertGap = function insertGap(values, gap) {
  var array = splitToWords(values);

  if (array) {
    return array.map(function (col, i, arr) {
      return gap && i + 1 < arr.length ? "".concat(col, " ").concat(gap) : col;
    }).join(" ");
  }

  return undefined;
};

export default insertGap;